/**************************************************
 * Nombre:       Formulario_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, Flag, TitleOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSEVENTO} from "../../Constantes";
import IngresoVideo from "../../Modulo_formularios/Componentes/IngresoVideo";

const Formulario_Testimonio = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Video Vertical</Typography>
                </Grid>


                <Grid container size={7}>
                    <IngresoVideo dato={'video'} {...props} />
                </Grid>



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo'} dato={'titulo'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre de la persona'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={8} nombre={'Descripcion'} dato={'parrafoUno'} {...props}
                    />
                </Grid>




            </Grid>

        </form>

    )

}
export default Formulario_Testimonio